// extracted by mini-css-extract-plugin
export default {"contractInfo":"ContractInfoCard_contractInfo__0ng1x","contractName":"ContractInfoCard_contractName__ix--J"};